import React from 'react'
import { jt, t } from 'ttag'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

class QuickAssessment extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hoverItem: null,
      firstInterest: null,
      secondInterest: null,
      thirdInterest: null
    }
    this.toggleHover = this.toggleHover.bind(this)
  }

  defaultInstructionTitle = t`Assess Yourself`
  defaultInstructionText = t`Use your mouse to hover over the interest areas on the left. A description of each area will appear here.  When you have read each area, select the three that you feel best describe your interests.`

  toggleHover = id => {
    /*
     * const mouseoverEvent = new Event('mouseover');
     * const ele = document.getElementById(id)
     * ele.dispatchEvent(mouseoverEvent);
     */
    const interest = this.props.interests.find(i => i.id === id)

    this.setState({
      ...this.state,
      hoverItem: interest
    })
  }

  toggleHoverOut = id => {
    this.setState({
      ...this.state,
      hoverItem: null
    })
  }

  toggleClick = id => {
    if (this.isSelected(id)) {
      return
    }

    console.log(id)
    const clickEvent = new Event('click')
    const ele = document.getElementById(id)

    console.log(ele, id)
    ele.dispatchEvent(clickEvent)

    if (this.state.secondInterest) {
      this.setState({ ...this.state, thirdInterest: id })
    } else if (this.state.firstInterest) {
      this.setState({ ...this.state, secondInterest: id })
    } else {
      this.setState({ ...this.state, firstInterest: id })
    }
  }

  selectInterest = pos => interest => {
    switch (pos) {
      case 0:
        this.setState({ ...this.state, firstInterest: interest.target.value })
        break
      case 1:
        this.setState({ ...this.state, secondInterest: interest.target.value })
        break
      case 2:
        this.setState({ ...this.state, thirdInterest: interest.target.value })
        break
    }

    console.log(this.state)
  }

  isSelected = area => {
    return (
      this.state.thirdInterest === area ||
      this.state.secondInterest === area ||
      this.state.firstInterest === area
    )
  }

  generateDesc = () => {
    const filterInterests = key => {
      return this.state[key] ? (
        <b>{this.props.interests.find(i => i.id === this.state[key])?.name}</b>
      ) : null
    }
    const i3 = filterInterests('thirdInterest')
    const i2 = filterInterests('secondInterest')
    const i1 = filterInterests('firstInterest')

    if (this.state.thirdInterest) {
      return jt`${i3} is the final part of your theme code. Jobs selected for you will reflect ${i2} interests in ${i1} environments with ${i3} goals.`
    }

    if (this.state.secondInterest) {
      return jt`This is your secondary interest. Jobs selected for you will reflect ${i2} interests in ${i1} environments.`
    }

    if (this.state.firstInterest) {
      return jt`This means that your primary interests lie in the ${i1} realm. The jobs selected for you will reflect this ${i1} theme.`
    }

    return null
  }

  render() {
    return (
      <div className="container">
        <div id="quick" className="sectionWrap">
          <div id="desc">
            <h3>{this.state?.hoverItem?.name ?? this.defaultInstructionTitle}</h3>
            <p className="hidden-xs hidden-sm">
              {this.state?.hoverItem?.description ?? this.defaultInstructionText}
            </p>
            <p className="visible-xs visible-sm">
              {t`Click on each of the interest areas below and read each of the descriptions that appear.  When you have read each area, select the three that you feel best describe your interests`}
            </p>
          </div>
          <p className="instructions">{t`First, read the following descriptions of the six interest areas.`}</p>

          <div
            className="panel-group visible-xs visible-sm"
            id="accordion"
            role="tablist"
            aria-multiselectable="true">
            {this.props.interests.map((i, idx) => (
              <div className="panel panel-default">
                <div className="panel-heading" role="tab" id={`heading${idx}`}>
                  <h4 className="panel-title">
                    <a
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href={`#collapse${idx}`}
                      aria-expanded="true"
                      aria-controls="collapseOne">
                      {i.name}
                    </a>
                  </h4>
                </div>
                <div
                  id={`collapse${idx}`}
                  className="panel-collapse collapse in"
                  role="tabpanel"
                  aria-labelledby="headingOne">
                  <div className="panel-body">{i.description}</div>
                </div>
              </div>
            ))}
            <br className="clear" />
          </div>

          <div id="quickassessment" className="hidden-xs hidden-sm">
            <img
              src="/images/common/transparent.gif"
              className="mapimage"
              useMap="#imagemap"
              width="100%"
              height="100%"
            />
            <ul>
              {this.props.interests.map((i, idx) => (
                <li className={`${i.id} item`}>
                  <span className="lbl"></span>
                  <a
                    id={i.id}
                    className={`element-name ${
                      this.state.hoverItem?.id === i.id ? 'hover' : ''
                    } ${this.isSelected(i.id) ? 'selected' : ''}`}
                    href="javscript:void(0)">
                    <div className={`${i.id}text text-item`}>
                      <span>{i.name}</span>
                    </div>
                  </a>
                  <span className="elementdesc">{i.description}</span>
                </li>
              ))}
            </ul>
          </div>
          <p className="instructions">{t`Now, select the three that you feel best describe your interests.`}</p>
          <form id="selections" className="with-border">
            <div className="chosen-title">{t`You Chose`}</div>
            <fieldset id="fields">
              <div className="row" style={{ padding: '0 15px' }}>
                <div
                  className="col-xs-12 col-sm-4 qa-options"
                  style={{ padding: '0 5px' }}>
                  <div className="input-group">
                    <label className="input-group-addon input-sm" htmlFor="i1">
                      1.
                    </label>
                    <select
                      name="i1"
                      id="i1"
                      className="form-control input-sm"
                      value={this.state.firstInterest}
                      onChange={this.selectInterest(0)}
                      autoComplete="off">
                      {this.state.firstInterest ? null : (
                        <option key={'i1choose1'}>{t`Choose One`}</option>
                      )}
                      {this.props.interests.map((i, idx) => (
                        <option key={`i1${i.id}`} value={i.id}>
                          {i.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div
                  className="col-xs-12 col-sm-4 qa-options"
                  style={{ padding: '0 5px' }}>
                  <div className="input-group">
                    <label className="input-group-addon input-sm" htmlFor="i2">
                      2.
                    </label>
                    <select
                      name="i2"
                      className="form-control input-sm"
                      id="i2"
                      value={this.state.secondInterest}
                      disabled={!this.state.firstInterest}
                      onChange={this.selectInterest(1)}
                      autoComplete="off">
                      {this.state.secondInterest ? null : (
                        <option key={'i2choose1'}>{t`Choose One`}</option>
                      )}
                      {this.props.interests.map((i, idx) => (
                        <option
                          key={`i2${i.id}`}
                          disabled={i.id === this.state.firstInterest}
                          value={i.id}>
                          {i.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div
                  className="col-xs-12 col-sm-4 qa-options"
                  style={{ padding: '0 5px' }}>
                  <div className="input-group">
                    <label className="input-group-addon input-sm" htmlFor="i3">
                      3.
                    </label>
                    <select
                      name="i3"
                      className="form-control input-sm"
                      id="i3"
                      value={this.state.thirdInterest}
                      disabled={!this.state.secondInterest}
                      onChange={this.selectInterest(2)}
                      autoComplete="off">
                      {this.state.thirdInterest ? null : (
                        <option key={'i3choose1'}>{t`Choose One`}</option>
                      )}
                      {this.props.interests.map((i, idx) => (
                        <option
                          key={`i3${i.id}`}
                          disabled={
                            i.id === this.state.firstInterest ||
                            i.id === this.state.secondInterest
                          }
                          value={i.id}>
                          {i.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div id="selection-desc">{this.generateDesc()}</div>
            </fieldset>
            <Link
              to={
                this.state.thirdInterest
                  ? `/quick/${this.state.firstInterest}${this.state.secondInterest}${this.state.thirdInterest}`
                  : '#'
              }
              className={`btn btn-success fade ${this.state.thirdInterest ? 'in' : ''}`}
              key="view-results-button"
              id="qa-submit">
              {t`View Results`}
            </Link>
          </form>
        </div>

        <br className="clear" />
        <map name="imagemap">
          <area
            shape="poly"
            coords="34,111,108,18,228,3,230,225"
            href="javascript:void(0)"
            onMouseOver={() => this.toggleHover('r')}
            onMouseOut={() => this.toggleHoverOut('r')}
            onClick={() => this.toggleClick('r')}
            alt="Realistic"
          />
          <area
            shape="poly"
            coords="434,105,231,227,232,-3,339,13"
            href="javascript:void(0)"
            onMouseOver={() => this.toggleHover('i')}
            onMouseOut={() => this.toggleHoverOut('i')}
            onClick={() => this.toggleClick('i')}
            alt="Investigative"
          />
          <area
            shape="poly"
            coords="237,223,437,113,460,218,441,347"
            href="javascript:void(0)"
            onMouseOver={() => this.toggleHover('a')}
            onMouseOut={() => this.toggleHoverOut('a')}
            onClick={() => this.toggleClick('a')}
            alt="Artistic"
          />
          <area
            shape="poly"
            coords="228,219,426,345,363,430,235,461"
            href="javascript:void(0)"
            onMouseOver={() => this.toggleHover('s')}
            onMouseOut={() => this.toggleHoverOut('s')}
            onClick={() => this.toggleClick('s')}
            alt="Social"
          />
          <area
            shape="poly"
            coords="232,229,29,347,98,429,232,476"
            href="javascript:void(0)"
            onMouseOver={() => this.toggleHover('e')}
            onMouseOut={() => this.toggleHoverOut('e')}
            onClick={() => this.toggleClick('e')}
            alt="Enterprising"
          />
          <area
            shape="poly"
            coords="31,108,226,228,28,344,-6,227"
            href="javascript:void(0)"
            onMouseOver={() => this.toggleHover('c')}
            onMouseOut={() => this.toggleHoverOut('c')}
            onClick={() => this.toggleClick('c')}
            alt="Conventional"
          />
        </map>
      </div>
    )
  }
}

export default connect(
  state => {
    return {
      interests: [
        {
          name: t`Realistic`,
          id: 'r',
          description: t`Realistic occupations frequently involve work activities that include practical, hands-on problems and solutions. They often deal with plants, animals, and real-world materials like wood, tools, and machinery. Many of the occupations require working outside, and do not involve a lot of paperwork or working closely with others.`
        },
        {
          name: t`Investigative`,
          id: 'i',
          description: t`Investigative occupations frequently involve working with ideas, and require an extensive amount of thinking. These occupations can involve searching for facts and figuring out problems mentally.`
        },
        {
          name: t`Artistic`,
          id: 'a',
          description: t`Artistic occupations frequently involve working with forms, designs and patterns. They often require self-expression and the work can be done without following a clear set of rules.`
        },
        {
          name: t`Social`,
          id: 's',
          description: t`Social occupations frequently involve working with, communicating with, and teaching people. These occupations often involve helping or providing service to others.`
        },
        {
          name: t`Enterprising`,
          id: 'e',
          description: t`Enterprising occupations frequently involve starting up and carrying out projects. These occupations can involve leading people and making many decisions. Sometimes they require risk taking and often deal with business.`
        },
        {
          name: t`Conventional`,
          id: 'c',
          description: t`Conventional occupations frequently involve following set procedures and routines. These occupations can include working with data and details more than with ideas. Usually there is a clear line of authority to follow.`
        }
      ]
    }
  },
  dispatch => ({
    dispatch
  })
)(QuickAssessment)
